<template>
    <header class="detail-hero">
        <NuxtLink v-if="breadcrumbLink && breadcrumbLabel" :to="breadcrumbLink" class="detail-hero__breadcrumb">{{ breadcrumbLabel }}</NuxtLink>
        <h1 class="detail-hero__title">{{ title }}</h1>
        <slot name="label" />
        <div v-if="description" class="detail-hero__description" v-html="description" />
        <InView
            v-if="image"
            :threshold="0.0"
            class="detail-hero__image"
        >
            <slot name="image">
                <BaseImage
                    :image
                    preserve-aspect-ratio
                    sizes="(min-width: 1025px) 540px, 95vw"
                />
            </slot>
            <DrawMarker v-if="image" class="detail-hero__image-marker" :marker="markermask" />
        </InView>
    </header>
</template>

<script setup>
defineProps({
    breadcrumbLink: {
        type: String,
        default: ''
    },
    breadcrumbLabel: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        default: null
    },
    labelText: {
        type: String,
        default: null
    },
    labelLink: {
        type: String,
        default: null
    },
    description: {
        type: String,
        default: null
    },
    cta: {
        type: Object,
        default: null
    },
    footerText: {
        type: String,
        default: null
    },
    markermask: {
        type: String,
        default: '1'
    },
    image: {
        type: Object,
        default: null
    }
});
</script>

<style lang="less" src="./DetailHero.less" />
